import { render } from "./favorite_button.vue?vue&type=template&id=30ca97c8"
import script from "./favorite_button.js?vue&type=script&lang=js&external"
export * from "./favorite_button.js?vue&type=script&lang=js&external"

import "./favorite_button.vue?vue&type=style&index=0&id=30ca97c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__